module.exports = __webpack_public_path__ + "static/img/min-button.96531a41.png";